module.exports = __webpack_public_path__ + "img/18_30.f2781150.png";